import { Flex } from '@chakra-ui/react'
import { Th } from '@chakra-ui/table'
import { AiOutlineArrowUp } from 'react-icons/ai'

export function ThUsage({ text }) {
  return (
    <Th
      textAlign="center"
      fontSize="0.770rem"
      fontWeight="bold"
      color="white"
      bg="#378BBF"
      paddingInline={0}
      maxW="1rem"
      minW="1rem"
    >
      {text !== 'VENCIMENTO' && text}
      {text === 'VENCIMENTO' && (
        <Flex justifyContent="center" alignItems="center">
          <span>{text}</span>
        </Flex>
      )}
    </Th>
  )
}
